var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNoMobileNumber(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2126_11150)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M55.5078 4.23828H47.3047H39.1016C31.1868 4.23828 24.6094 10.679 24.6094 18.5938C24.6094 25.8136 30.1034 31.8057 37.0508 32.8031V39.1016C37.0508 39.9306 37.5494 40.6797 38.3165 40.9961C39.073 41.3118 39.9603 41.1425 40.5516 40.5515L47.3047 33.7984L48.1538 32.9492H55.5078C63.4226 32.9492 70 26.5085 70 18.5938C70 10.679 63.4226 4.23828 55.5078 4.23828Z",
    fill: "#E6ECFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.5078 32.9492C63.4226 32.9492 70 26.5085 70 18.5938C70 10.679 63.4226 4.23828 55.5078 4.23828H47.3047V33.7984L48.1538 32.9492H55.5078Z",
    fill: "#E6ECFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.2266 51.4062V59.6094C52.2266 63.1777 49.3131 65.7617 46.1029 65.7617C34.2891 65.7617 22.7637 60.1768 14.1914 51.6387C5.61914 43.1006 0 31.6094 0 19.7955C0 16.4021 2.76035 13.6719 6.15234 13.6719H14.3555C15.2387 13.6719 16.0221 14.2365 16.2996 15.0732L20.4012 27.3492C20.6021 27.9508 20.5133 28.6098 20.1633 29.1361L16.6852 34.3547C18.0031 37.1191 20.3355 40.1406 23.0289 42.8012C25.7236 45.4604 28.7793 47.7586 31.5438 49.0766L36.7623 45.5984C37.2914 45.2498 37.9477 45.1582 38.5492 45.3605L50.8539 49.4621C51.6906 49.7396 52.2266 50.523 52.2266 51.4062Z",
    fill: "#00ACB9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.2266 51.4059V59.609C52.2266 63.1773 49.3131 65.7613 46.1029 65.7613C34.2891 65.7613 22.7637 60.1764 14.1914 51.6383L23.0289 42.8008C25.7236 45.46 28.7793 47.7582 31.5437 49.0762L36.7623 45.598C37.2914 45.2494 37.9477 45.1578 38.5492 45.3602L50.8539 49.4617C51.6906 49.7393 52.2266 50.5227 52.2266 51.4059Z",
    fill: "#00ACB9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.1016 20.6445C40.2342 20.6445 41.1523 19.7264 41.1523 18.5937C41.1523 17.4611 40.2342 16.543 39.1016 16.543C37.9689 16.543 37.0508 17.4611 37.0508 18.5937C37.0508 19.7264 37.9689 20.6445 39.1016 20.6445Z",
    fill: "#00ACB9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.3047 20.6445C48.4373 20.6445 49.3555 19.7264 49.3555 18.5938C49.3555 17.4611 48.4373 16.543 47.3047 16.543C46.1721 16.543 45.2539 17.4611 45.2539 18.5938C45.2539 19.7264 46.1721 20.6445 47.3047 20.6445Z",
    fill: "#00ACB9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.3555 18.5938C49.3555 17.4612 48.4373 16.543 47.3047 16.543V20.6445C48.4373 20.6445 49.3555 19.7263 49.3555 18.5938Z",
    fill: "#00ACB9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.5078 20.6445C56.6404 20.6445 57.5586 19.7264 57.5586 18.5937C57.5586 17.4611 56.6404 16.543 55.5078 16.543C54.3752 16.543 53.457 17.4611 53.457 18.5937C53.457 19.7264 54.3752 20.6445 55.5078 20.6445Z",
    fill: "#00ACB9"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2126_11150"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 70,
    height: 70,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoMobileNumber);
export default __webpack_public_path__ + "static/media/no_mobile_number.fc694a382ae58294ccb5ddb88e28928c.svg";
export { ForwardRef as ReactComponent };